"use strict";
var isObject = require("../internals/is-object");
var createNonEnumerableProperty = require("../internals/create-non-enumerable-property");
module.exports = function(O, options) {
  if (isObject(options) && "cause" in options) {
    createNonEnumerableProperty(O, "cause", options.cause);
  }
};
